const timeLeft = (time?: Date): string => {
  if (!time) {
    return 'N/A';
  }
  
  
  let diff = (time.getTime() - new Date().getTime()) / 1000;

  let months = Math.floor(diff / (30 * 86400));
  diff -= months * (30 * 86400);
  let weeks = Math.floor(diff / (7 * 86400));
  diff -= weeks * (7 * 86400);
  let days = Math.floor(diff / 86400);
  diff -= days * 86400;
  let hours = Math.floor(diff / 3600);
  diff -= hours * 3600;
  let minutes = Math.floor(diff / 60);
  diff -= minutes * 60;
  let seconds = diff;

  if (months > 1) {
    return months === 1 ? 'in 1 month' : `in ${months} months`;
  } else if (weeks > 0) {
    return weeks === 1 ? 'in 1 week' : `in ${weeks} weeks`;
  } else if (days > 0) {
    return days === 1 ? 'in 1 day' : `in ${days} days`;
  } else if (hours > 0) {
    return hours === 1 ? 'in 1 hour' : `in ${hours} hours`;
  } else if (minutes > 0) {
    return minutes === 1 ? 'in 1 minute' : `in ${minutes} minutes`;
  } else if (seconds > 0) {
    return 'in a few seconds ago';
  }

  return time.toString();
};

export default timeLeft;